import { lazy } from 'react';

export const TopicList = lazy(() => import('./TopicList'));
export const AddTopic = lazy(() => import('./AddTopic'));
export const UpdateTopic = lazy(() => import('./UpdateTopic'));
export const TopicQuestionList = lazy(() => import('./TopicQuestionList'));
export const AddTopicQuestion = lazy(() => import('./AddTopicQuestion'));
